module.exports = "/assets/data/31fbf72bb7290140dbf01f93724cb03a-HP10.data.json";